module.exports = __webpack_public_path__ + "annai/images/eyecatch.png?5cb9b27027e9f1941528d0b0637af0cc";